import * as Yup from 'yup';

export const validationSchema = Yup.object({
  serie: Yup.string().required('Campo obrigatório.'),
});
